import React from 'react';
import { Routes, Route } from "react-router-dom";

import Layout from '../component/Layout';
import EmptyLayout from '../component/EmptyLayout';
import RequireAuth from './auth/RequireAuth';

import LoginPage from '../component/dump/forms/login/LoginPage';
import ConfirmationPage from '../component/dump/forms/login/ConfirmationPage';
import RestorePasswordPage from '../component/dump/forms/login/RestorePasswordPage';
import ResetPasswordPage from '../component/dump/forms/login/ResetPasswordPage';
import NotFoundComponent from '../component/dump/NotFoundComponent';
import HomeAccess from '../component/smart/menuComponentsContainer/HomeAccess';
import ChangePasswordContainer from '../component/smart/menuComponentsContainer/ChangePasswordContainer';
import CompanyContainer from '../component/smart/menuComponentsContainer/CompanyContainer';
import CompanyEditContainer from '../component/smart/menuComponentsContainer/CompanyEditContainer';
import AccountUserContainer from '../component/smart/account/AccountUserContainer';
import AccountSettings from '../component/smart/account/AccountSettings';
import SupportContainer from '../component/smart/menuComponentsContainer/SupportContainer';
import ManageVehicles from '../component/smart/menuComponentsContainer/ManageVehicles';
import SSOHandler from "./auth/SSOHandler";

const AppRoutes = () => {
	return (
		<Routes>
			<Route element={<EmptyLayout />}>
				<Route path="/login" element={<LoginPage />} />
				<Route path="/sso" element={<SSOHandler />} />
				<Route path="/restore-password" element={<RestorePasswordPage />} />
				<Route path="/reset-password" element={<ResetPasswordPage />} />
				<Route path="/not-found" element={<NotFoundComponent />} />
				<Route path="/confirmation" element={<ConfirmationPage />} />
			</Route>
			<Route element={<RequireAuth />}>
				<Route path="/" element={<Layout />}>
					<Route index element={<HomeAccess />} />
					<Route path="support" element={<SupportContainer />} />
					<Route path="managevehicles" element={<ManageVehicles />} />
					<Route path="account/settings" element={<AccountSettings />} />
					<Route path="manageusers/change-password" element={<ChangePasswordContainer />} />
					<Route path="company" element={<CompanyContainer />} />
					<Route path="company/edit" element={<CompanyEditContainer />} />
					<Route path="account" element={<AccountUserContainer />} />
				</Route>
			</Route>
		</Routes>
	)
}

export default AppRoutes;
